module.exports = __webpack_public_path__ + "media/reskin-images/icon--events-a8236e7b.svg";